/**
 * @description 공통 모달에 사용될 메시지 및 버튼 텍스트 상수
 */
export interface ModalContent {
    title: string;
    text: string;
    text2?: string;
    whiteBtnText?: string;
    blackBtnText?: string;
}

const confirmAgencyDelete: ModalContent = {
    title: '안내',
    text: '연동을 삭제하시겠습니까?',
    whiteBtnText: '취소',
    blackBtnText: '삭제',
} as const;

const apiFail: ModalContent = {
    title: '처리실패',
    text: '처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
    whiteBtnText: "",
    blackBtnText: '확인',
}

const agencyDeleteSuccess: ModalContent = {
    title: '안내',
    text: '삭제되었습니다.',
    whiteBtnText: "",
    blackBtnText: '확인',
}

const autoAcceptSwitcherOn: ModalContent = {
    title: '주문 자동 접수 설정',
    text: '신규주문알림팝업 없이 주문이 자동 접수처리 됩니다.',
    text2: '그래도 설정하시겠습니까?',
    whiteBtnText: '취소',
    blackBtnText: '자동 접수 설정',
}

const autoAcceptSwitcherOff: ModalContent = {
    title: '주문 자동 접수 해제',
    text: '설정 해제시, 신규주문알림팝업에서 주문을 접수해야 합니다.',
    text2: '그래도 설정하시겠습니까?',
    whiteBtnText: '취소',
    blackBtnText: '자동 접수 설정 해제',
}


export const ModalMessages = {
    CONFIRM_AGENCY_DELETE: confirmAgencyDelete,
    AGENCY_DELETE_SUCCESS: agencyDeleteSuccess,
    API_FAIL: apiFail,

    AUTO_ACCEPT_SWITCHER_ON: autoAcceptSwitcherOn,
    AUTO_ACCEPT_SWITCHER_OFF: autoAcceptSwitcherOff,
};